import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class EventSelectorComponent extends Component
{
	@service store;

	@action
	async selectEvent(event)
	{
		if(event.target.value == '-')
		{
			this.args.eventSelectionAction(null);
		}
		else
		{
			const foundEvent = await this.store.findRecord('Event', event.target.value);
			this.args.eventSelectionAction(foundEvent);
		}
	}
}
